export default __webpack_public_path__ + "1c923ee42bf525c10b1a4d9f8824601a.webp";